import {
  getStripeConnectUrl,
  getStripeLoginUrl,
  removeStripe,
} from '@client/new/api/stripe.api';
import { PrimaryButton } from '@client/new/components/button';
import { useUser } from '@client/new/hooks/use-user';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { StripePaymentMethodAlert } from './StripePaymentMethodAlert';

const StripeConnect = () => {
  const { influencer, user } = useUser();

  const url = getStripeConnectUrl(user?.email, influencer || {});

  return (
    <a href={url}>
      <PrimaryButton>Connect Stripe</PrimaryButton>
    </a>
  );
};

const StripeConnectDashboard = () => {
  const { influencer } = useUser();
  const [url, setUrl] = useState('');

  useEffect(() => {
    if (influencer) {
      getStripeLoginUrl(influencer.id).then((res) => {
        setUrl(res);
      });
    }
  }, [influencer]);

  return (
    <a
      className="bg-primary rounded-full px-10 py-4 text-white font-bold"
      href={url}
    >
      Go to dashboard
    </a>
  );
};

const RemoveStripe = () => {
  const { influencer, refetchInfluencer } = useUser();

  const remove = useCallback(() => {
    if (!influencer?.id) return;
    removeStripe(influencer.id)
      .then(() => toast.success('Stripe removed'))
      .then(() => refetchInfluencer())
      .catch(() => toast.error('Error removing stripe'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [influencer]);

  return (
    <button
      className="bg-gray-200 rounded-full px-10 py-4 text-zinc-900 font-bold"
      onClick={remove}
    >
      Remove Stripe
    </button>
  );
};

export const StripeConnectSettings = () => {
  const { influencer } = useUser();

  if (!influencer) {
    return <p>Stripe Connect is only available for creators.</p>;
  }

  if (influencer?.stripeUserId) {
    return (
      <div className="flex flex-col gap-2">
        <StripePaymentMethodAlert />
        <p>Stripe connected</p>
        <div className="flex gap-2">
          <StripeConnectDashboard />
          <RemoveStripe />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2 items-start">
      <p>Stripe not connected</p>
      <div className="flex gap-2">
        <StripeConnect />
      </div>
    </div>
  );
};
